import Utils from "../Common/Utils";
import { TResponseData, TdoGet, TdoPost} from './types'

const doPost: TdoPost = async (
  url,
  inputdata = null,
  authdata = null,
  token = null,
  isFileUpload = false
) => {
  if(!url) throw new Error("Url not found")
  let retObj: TResponseData = {};
  try {
    let authString =
      authdata != null
        ? "Basic " +
          btoa(authdata.email + ":" + authdata.password)
        : null;

    if (authString === null) {
      authString = token != null ? "Bearer " + token : null;
    }
    var formBody = inputdata;
    if (!isFileUpload && inputdata !== null) {
      const sanitizedData = JSON.parse(JSON.stringify(inputdata, (_, value) =>
        Number.isNaN(value) ? null : value
      ));
      formBody = JSON.stringify(sanitizedData);
    }
    var headersObj: HeadersInit = {
      Accept: "application/json",
      "Content-Type": isFileUpload ? "multipart/form-data" : "application/json",
      Authorization: authString ?? "",
    };
    if (isFileUpload) {
      headersObj = {
        Authorization: authString ?? "",
      };
    }
    const rawResponse = await fetch(url, {
      method: "POST",
      headers: headersObj,
      body: formBody,
    });
    const rawData = await rawResponse.text();
    const sanitizedResponseData = rawData.replace(/:\s*NaN/g, ': null');
    retObj.data = JSON.parse(sanitizedResponseData);
    retObj.errorfound = false;
  } catch (error) {
    retObj = { errorfound: true, errorbj: error, data: null };
  } 
  retObj = check_token_expired(retObj);
  return retObj;
};

const doPut: TdoPost = async (
  url,
  inputdata = null,
  authdata = null,
  token = null,
  isFileUpload = false
) => {
  let retObj: TResponseData = {};
  try {
    if(!url) throw new Error("url cannot be empty");
    let authString =
      authdata != null
        ? "Basic " +
          btoa(authdata.email + ":" + authdata.password)
        : null;

    if (authString === null) {
      authString = token != null ? "Bearer " + token : null;
    }
    var formBody = inputdata;
    if (!isFileUpload && inputdata !== null) {
      formBody = JSON.stringify(inputdata);
    }

    var headersObj: HeadersInit = {
      Accept: "application/json",
      "Content-Type": isFileUpload ? "multipart/form-data" : "application/json",
      Authorization: authString ?? '',
    };
    if (isFileUpload) {
      headersObj = {
        Authorization: authString ?? '',
      };
    }

    const rawResponse = await fetch(url, {
      method: "PUT",
      headers: headersObj,
      body: formBody,
    });
    retObj.data = await rawResponse.json();
    retObj.errorfound = false;
  } catch (error) {
    retObj = { errorfound: true, errorbj: error, data: null };
  }
  retObj = check_token_expired(retObj);
  return retObj;
};

const doGet: TdoGet = async (url, inputdata, authdata = null, token = null) => {
  let retObj: TResponseData = {};
  try {
    if(!url) throw new Error("url cannot be empty");

    let authString =
      authdata != null
        ? "Basic " +
          btoa(authdata.email + ":" + authdata.password)
        : null;

    if (authString === null) {
      authString = token != null ? "Bearer " + token : null;
    }
    const rawResponse = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: authString ?? "",
      },
    });
    retObj.data = await rawResponse.json();
    retObj.errorfound = false;
  } catch (error) {
    retObj = { errorfound: true, errorbj: error, data: null };
  } finally {
  }
  retObj = check_token_expired(retObj);
  return retObj;
};

const doDelete: TdoGet = async (url, inputdata, authdata = null, token = null) => {
  let retObj: TResponseData = {};
  try {
    if(!url) throw new Error("url cannot be empty");

    let authString =
      authdata != null
        ? "Basic " +
          btoa(authdata.email + ":" + authdata.password)
        : null;

    if (authString === null) {
      authString = token != null ? "Bearer " + token : null;
    }
    var formBody = inputdata;
    if (inputdata !== null) {
      formBody = JSON.stringify(inputdata);
    }
    const rawResponse = await fetch(url, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: authString ?? "",
      },
      body: formBody,
    });
    retObj.data = await rawResponse.json();
    retObj.errorfound = false;
  } catch (error) {
    retObj = { errorfound: true, errorbj: error, data: null };
  }
  retObj = check_token_expired(retObj);
  return retObj;
};

const check_token_expired = (ret: any) => {
  if (ret.data != null) {
    if (ret.data.hasOwnProperty("msg"))
      if (ret.data.msg === "Token has expired") {
        ret.errorfound = true;
        (window["bootbox" as any] as any).dialog({
          title: "Session Expired",
          message:
            "<p>Your Session is expired. You will have to login again to the system</p>",
          size: "medium",
          centerVertical: true,
          closeButton: false,
          buttons: {
            ok: {
              label: "OK, I got it",
              className: "btn-info btn-sm",
              callback: function () {
                var redirect_url = Utils.get_current_root_url() + "logout";
                window.location.href = redirect_url;
              },
            },
          },
        });
      }
  }
  return ret;
};

const doPatch: TdoPost = async (
  url,
  inputdata = null,
  authdata = null,
  token = null,
  isFileUpload = false
) => {
  let retObj: TResponseData = {};
  try {
    if(!url) throw new Error("url cannot be empty");
    let authString =
      authdata != null
        ? "Basic " +
          btoa(authdata.email + ":" + authdata.password)
        : null;

    if (authString === null) {
      authString = token != null ? "Bearer " + token : null;
    }
    var formBody = inputdata;
    if (!isFileUpload && inputdata !== null) {
      formBody = JSON.stringify(inputdata);
    }

    var headersObj: HeadersInit = {
      Accept: "application/json",
      "Content-Type": isFileUpload ? "multipart/form-data" : "application/json",
      Authorization: authString ?? '',
    };
    if (isFileUpload) {
      headersObj = {
        Authorization: authString ?? '',
      };
    }

    const rawResponse = await fetch(url, {
      method: "PATCH",
      headers: headersObj,
      body: formBody,
    });
    retObj.data = await rawResponse.json();
    retObj.errorfound = false;
  } catch (error) {
    retObj = { errorfound: true, errorbj: error, data: null };
  }
  retObj = check_token_expired(retObj);
  return retObj;
};

const ServiceWrapper = { doPost, doGet, doDelete, doPut, doPatch }
export default ServiceWrapper;
